import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./alert.css";
export const MySwal = withReactContent(Swal);
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  showClass: {
    popup: "animate__animated animate__fadeInDown",
  },
  hideClass: {
    popup: "animate__animated animate__fadeOutUp",
  },
});
export const ConfirmDelete = async () => {
  let res = await MySwal.fire({
    title: "Do you want to delete item ?",

    //text: "To delete: "+txt,
    //type: 'warning',
    showCancelButton: true,
    confirmButtonColor: "",
    cancelButtonColor: "",
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    showCloseButton: true,
    // showClass: {
    //   popup: "animated fadeInDown faster",
    //   backdrop: "swal-overlay",
    //   //icon: '',
    // },
    // hideClass: {
    //   popup: "animated fadeOutUp faster",
    // },
  });
  return res.value || false;
};
export const ConfirmSave = async () => {
  let res = await MySwal.fire({
    title: "This plan will be execute immediately after submit.",
    showCancelButton: true,
    confirmButtonColor: "",
    cancelButtonColor: "",
    confirmButtonText: "ok",
    cancelButtonText: "cancel",
    showCloseButton: true,
  });
  return res.value || false;
};
export const ConfirmCommon = async (text = "", yes = "ok", no = "cancel") => {
  let res = await MySwal.fire({
    title: text,
    showCancelButton: true,
    confirmButtonColor: "",
    cancelButtonColor: "",
    confirmButtonText: yes,
    cancelButtonText: no,
    showCloseButton: true,
  });
  return res.value || false;
};
export const del_success = () => {
  MySwal.fire({
    icon: "success",
    title: "Deleted!",
    showConfirmButton: false,
    timer: 1500,
  });
};
export const inform_success = async (txt) => {
  await MySwal.fire({
    icon: "success",
    title: txt || "success!",
    showConfirmButton: false,
    timer: 1000,
  });
};
export const information = async (txt) => {
  let res = await MySwal.fire({
    title: txt,
    showCancelButton: false,
    confirmButtonColor: "",
    cancelButtonColor: "",
    confirmButtonText: "OK",
    showCloseButton: true,
  });
  return res.value || false;
};
export const apiError = (err) => {
  Toast.fire({
    width: "25em",
    icon: "error",
    title: "Api Error",
  });
  console.error("Toast", err);
};
export async function Inform(txt = "", html) {
  await MySwal.fire(txt, html);
}
export async function Informcurrentedit() {
  await Inform(
    "There is an uncommitted execution plan edit session. Please complete the edit session."
  );
}

export const ConnectSuccessDialog = (title) => {
  if (title === null || title === undefined) {
    title = "Connect Success";
  }
  MySwal.fire({
    icon: "success",
    title: title,
    showConfirmButton: false,
    timer: 5500,
    showClass: {
      popup: "animated fadeInDown faster",
      // backdrop: 'swal-overlay'
    },
    hideClass: {
      popup: "animated fadeOutUp faster",
    },
  });
};
export const ErrorDialog = (title) => {
  MySwal.fire({
    icon: "error",
    title: title,
    showConfirmButton: false,
    timer: 5500,
    // showClass: {
    //     popup: 'animated fadeInDown faster',
    //     backdrop: 'swal-overlay'
    // },
    hideClass: {
      popup: "animated fadeOutUp faster",
    },
  });
};

export const ErrorListDialog = (title, errorMessages) => {
  const formattedErrors = errorMessages
    .map((error) => `<li style="text-align: left; margin-left: 2em;">${error}</li>`)
    .join("");

  MySwal.fire({
    icon: "error",
    title: title,
    width: "40em",
    html: `<ul style="margin-top: 1em;">${formattedErrors}</ul>`,
    showConfirmButton: false,
    hideClass: {
      popup: "animated fadeOutUp faster",
    },
  });
};

export const ErrorDialogSQL = (msg) => {
  MySwal.fire({
    icon: "error",
    //title: title,
    width: "50em",
    showConfirmButton: false,
    text: msg,
    hideClass: {
      popup: "animated fadeOutUp faster",
    },
  });
};

export const Success = async (txt) => {
  await MySwal.fire({
    icon: "success",
    title: txt || " Success!",
    showConfirmButton: false,
    timer: 3000,
  });
};

export const SuccessShowButtonCloseModal = async (txt, event) => {
  await MySwal.fire({
    icon: "success",
    title: txt,
    showConfirmButton: true,
    allowOutsideClick: false,
  }).then((result) => {
    if (result.isConfirmed) {
      event.onClose();
      window.location.reload();
    }
  });
};
